import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useSuppliersList() {
  // Use toast
  const toast = useToast();

  const refSupplierListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "id", label: "編號", sortable: true, class: 'sticky-column' },
    { key: "project_name", class: 'sticky-column', label: "項目名稱", sortable: true },
    { key: "actions", class: 'sticky-column', label: "操作" },
    { key: "address", label: "工程地址", sortable: true },
    { key: "expenditure", label: "薪金支出", sortable: true, formatter: formatCurrency },
    { key: "pay_date", label: "支付日期", sortable: true },
    { key: "show_details", label: "工支及成本摘要" },
    { key: "authorizer", label: "授權人", sortable: true },
    { key: "status", label: "狀態", sortable: true },
    { key: "created_at", label: "創建日期", sortable: true },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refSupplierListTable.value
      ? refSupplierListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    // refSupplierListTable.value.refresh();
    fetchSuppliers();
  };

  const suppliersList = ref(null);


  watch(
    [currentPage, perPage, searchQuery, ],
    () => {
      refetchData();
    }
  );

  const fetchSuppliers = (ctx, callback) => {

    suppliersList.value = [{
      "id": "TSF00100",
      "order_number": "001234567",
      project_id: "P000031",
      project_name: "深灣一號10樓A室工程",
      address: "新界粉嶺, 馬適路過號",
      "expenditure": 40444,
      "pay_date": "20-07-2022",
      cost_summary: [
        {
          id: 1,
          event: { id: 1, name: '工資' },
          event_id: 1,
          supplier_name: "除俠",
          salary: '1000/日',
          position: '水電師傅',
          join_date: '03-04-2023, 8am-6pm（10小時）\n05-04-2023, 8am-6pm（10小時）',
        },
        {
          id: 2,
          event: { id: 2, name: '代購物資' },
          event_id: 2,
          remark: '防火膠板 690塊',
          quantity: '690',
          quit: '水電師傅',
          amount: "690",
        }
      ],
      "authorizer": "wing so",
      "status_id": 1,
      "status": { id: 1, name: '成功' },
      "created_at": "17-07-2022,13:00"
    }]
    // store
    //   .dispatch("supplier/fetchSuppliers", {
    //     q: searchQuery.value,
    //     perPage: perPage.value,
    //     page: currentPage.value,
    //     sortBy: sortBy.value,
    //     sortDesc: isSortDirDesc.value,
    //     gender_id: filter_gender_id.value,
    //     bank_id: filter_bank_id.value,
    //     payment_method_id: filter_payment_method_id.value,
    //     supplier_status_id: filter_supplier_status.value,
    //   })
    //   .then((response) => {
    //     const { suppliers, total } = response.data;
    //     callback(suppliers);
    //     totalRow.value = total;
    //     suppliersList.value = suppliers
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     toast({
    //       component: ToastificationContent,
    //       props: {
    //         title: "獲取貸款清單時出錯",
    //         icon: "AlertTriangleIcon",
    //         variant: "danger",
    //       },
    //     });
    //   });
  };

  // const genderOptions = ref([]);
  // const supplierStatusOptions = ref([]);
  // const bankOptions = ref([]);
  // const paymentMethodStatusOptions = ref([]);

  // const refetchOption = () => {
  //   store
  //     .dispatch("app/fetchOptionList", {
  //       genders: true,
  //       supplier_statuses: true,
  //       banks: true,
  //       payment_methods: true
  //     })
  //     .then((response) => {
  //       genderOptions.value = response.data.genders;
  //       supplierStatusOptions.value = response.data.supplier_statuses;
  //       bankOptions.value = response.data.banks;
  //       paymentMethodStatusOptions.value = response.data.payment_methods;
  //     });
  // };

  onMounted(() => {
    // refetchOption();
    refetchData();
  });

  return {
    fetchSuppliers,
    tableColumns,
    perPage,
    totalRow,
    currentPage,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    dataMeta,
    suppliersList,
    refSupplierListTable,
    ability,
    refetchData,
    // filter_gender_id,
    // filter_bank_id,
    // filter_payment_method_id,
    // filter_supplier_status,
    // genderOptions,
    // supplierStatusOptions,
    // bankOptions,
    // paymentMethodStatusOptions
  };
}
